import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center mt-5" style={{height: "100vh"}}>
            <h3 className="text-secondary fw-bold">This page is not found!!!</h3>
        </div>
    );
};

export default NotFound;